import React, { Component } from "react";
import styled from "styled-components";
import Link from "../Link";

const FooterItems = [
  { children: "關於好咖", url: "/about" },
  { children: "常見問題", url: "/faq" },
  { children: "服務條款", url: "/terms-of-service" },
  { children: "隱私權政策", url: "/privacy-policy" },
  { children: "退換貨政策", url: "/return-policy" }
];

class Footer extends Component {
  render() {
    let { extraStyle = "", isFooterDisplayNone } = this.props;

    return (
      <Wrapper
        extraStyle={extraStyle}
        isFooterDisplayNone={isFooterDisplayNone}
      >
        <Top>
          <div className="oval" />
          <div className="menu">
            {FooterItems.map((item, idx) => (
              <Link to={item.url} key={idx} className="nav-item">
                {item.children}
              </Link>
            ))}
          </div>
        </Top>

        <Line />

        <Bottom>
          <div className="info">
            <img src="/images/logo02.png" className="logo" />
            <div className="contact">
              <div className="phone">02-2557-8895</div>
              <div className="email">service@hecafe.com.tw</div>
            </div>
            <div className="container">
              <div className="address">台北市大同區民權西路136號10樓</div>
              <div className="copyright">© He Cafe. All rights reserved.</div>
              <a
                className="copyright"
                target="_blank"
                href="https://www.flaticon.com/authors/eucalyp"
              >
                Icon made by Eucalyp from www.flaticon.com
              </a>
            </div>
          </div>
        </Bottom>
      </Wrapper>
    );
  }
}

let Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #dacbbd;
  width: 100vw;
  color: #505050;
  ${props => (props.isFooterDisplayNone ? "display: none" : "")};
  ${props => props.extraStyle};
`;

let Top = styled.div`
  width: 100%;
  & > .oval {
    border-bottom-right-radius: 250%;
    border-bottom-left-radius: 250%;
    background: white;
    width: 100%;
    height: 55px;
  }
  & > .menu {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    max-width: 1120px;
    padding: 30px 35px;

    & > .nav-item {
      margin-right: 50px;
      cursor: pointer;
      text-decoration: none;
      letter-spacing: 0.3px;
      font-size: 14px;
      color: #ffffff;
    }

    & > .nav-item :last-child {
      margin-right: 0px;
    }
  }

  @media screen and (max-width: 725px) {
    & > .menu {
      & > .nav-item {
        margin-right: 25px;
      }
    }
  }
  @media screen and (max-width: 525px) {
    & > .menu {
      justify-content: flex-start;
      flex-wrap: wrap;
      max-width: 250px;
      padding: 30px 35px 20px;

      & > .nav-item {
        margin-right: 10px;
        margin-bottom: 10px;
        min-width: 80px;
      }
    }
  }
`;

let Line = styled.div`
  max-width: 1120px;
  width: 100%;
  height: 1px;
  background: white;
  transform: scaleY(0.5);
  transform-origin: 50% 100%;

  @media screen and (max-width: 1120px) {
    max-width: 90%;
  }
`;

let Bottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-grow: 1;
  max-width: 1120px;
  min-height: 95px;
  width: 100%;

  & > .info {
    display: flex;
    align-items: flex-start;
    margin: 0 auto;
    padding: 30px 40px;

    & > .logo {
      margin-right: 50px;
      width: 126px;
      height: 54px;
    }

    & > .contact {
      display: flex;
      min-width: 130px;
      margin-right: 20px;
      font-size: 13px;
      color: #755b41;

      & > .phone {
        margin-right: 50px;
        line-height: 18px;
      }
    }

    & > .container {
      min-width: 195px;
      margin: 0px 10px;
      text-align: right;
      font-size: 13px;
      color: #755b41;

      & > .address {
        line-height: 18px;
      }

      & > .copyright {
        font-size: 10px;
        letter-spacing: 0.29px;
        line-height: 18px;
        color: #755b41;
      }
    }
  }

  @media screen and (max-width: 768px) {
    & > .info {
      padding: 30px 20px;

      & > .contact {
        flex-wrap: wrap;

        & > .phone {
          margin-right: 0px;
          max-width: 100px;
          width: 100%;
        }
      }
    }
  }
  @media screen and (max-width: 570px) {
    max-width: 250px;
    width: 100%;

    & > .info {
      flex-wrap: wrap;
      padding: 30px 20px;

      & > .logo {
        margin-right: 0px;
        margin-bottom: 20px;
      }

      & > .contact {
        flex-direction: column;
        margin-right: 0px;
        margin-bottom: 20px;
        width: 100%;
      }

      & > .container {
        margin: 0px;
        text-align: left;
      }
    }
  }
`;

export default Footer;
